<div class="ds-card">
  <div class="ds-card__cabecera">
    <span class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFAS' | translate }}</span>
    <div class="col-10 ds-buscador">
      <span class="p-input-icon-left">
        <img src="assets/icons/ico-buscar-lupa.svg" alt="">
        <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroTarifas">
      </span>
    </div>
  </div>
  <p-table [value]="tarifasFiltradas" [loading]="cargandoTarifas" [paginator]="true" [rows]="10"
           [alwaysShowPaginator]="true" styleClass="ds-tabla">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODO' | translate }}</th>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO' | translate }}</th>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_HABILITADO' | translate }}</th>
        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tarifa>
      <tr>
        <td>{{ tarifa.metodo }}</td>
        <td>
          <span class="admsb-chip-estado" [ngClass]="claseEstado(tarifa.codigoEstado)">{{ tarifa.estado }}</span>
        </td>
        <td>
          <p-inputSwitch class="admsb-switch" [(ngModel)]="tarifa.habilitado" [disabled]="true"></p-inputSwitch>
        </td>
        <td class="text-center">
          <button type="button" class="btn-action-premium admsb-btn-icono"
                  title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFAS' | translate }}"
                  (click)="irATarifas(tarifa)">
            <img src="assets/icons/ico-dinero-circulo.svg" alt="">
          </button>
          <button type="button" class="btn-action-premium ds-btn-icono-editar"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  (click)="abrirSidebarEdicionTarifa(tarifa)">
            <span class="ds-icono-editar"></span>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-sidebar [(visible)]="sidebarVisible" position="right" styleClass="w-30rem admsb-sidebar-editar"
           transitionOptions="400ms cubic-bezier(0, 0, 0.2, 1)" [blockScroll]="true">
  <ng-template pTemplate="header">
    <span class="admsb-sidebar-editar__titulo">{{ tituloSidebar | translate }}</span>
  </ng-template>

  <div class="admsb-sidebar-editar__cuerpo">
    <div class="div-form">
      <label>*{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODO' | translate }}</label>
      <p-dropdown [options]="metodosPasarela" optionLabel="label" optionValue="value"
                  placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
                  [disabled]="true"
                  [(ngModel)]="tarifaEditando.idMetodo"></p-dropdown>
      <div class="p-message p-messages-error p-corner-all" *ngIf="submittedTarifa && !tarifaEditando.idMetodo">
        {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
      </div>
    </div>
    <div class="div-form">
      <label>*{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO' | translate }}</label>
      <p-dropdown [options]="estadosPasarela" optionLabel="label" optionValue="value"
                  placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
                  [(ngModel)]="tarifaEditando.idEstado"></p-dropdown>
      <div class="p-message p-messages-error p-corner-all" *ngIf="submittedTarifa && !tarifaEditando.idEstado">
        {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
      </div>
    </div>
    <div class="div-form flex align-items-center gap-2">
      <p-inputSwitch class="admsb-switch" [(ngModel)]="tarifaEditando.habilitado"></p-inputSwitch>
      <label class="mb-0">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_HABILITADO' | translate }}</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="admsb-sidebar-editar__footer">
      <button type="button" pButton class="btn-primary-outline"
              label="{{ 'BTN_CANCELAR' | translate }}"
              (click)="cerrarSidebarEdicion()"></button>
      <button type="button" pButton class="btn-primary-full" icon="fa fa-floppy-o"
              label="{{ 'BTN_GUARDAR' | translate }}"
              (click)="guardarTarifa()"></button>
    </div>
  </ng-template>
</p-sidebar>
